import {
  DrawerMenu,
  DrawerMenuItemType,
  Header,
  HeaderDrawerMenuPropsType,
  HeaderNavbarPropsType,
  HeaderNavPropsType,
  Nav,
  Navbar,
  NavbarMenuItemType,
  useScreenWidth,
} from "@/lib/main";
import { PropsWithChildren, useState } from "react";

type Props = PropsWithChildren<
  HeaderDrawerMenuPropsType &
    HeaderNavPropsType &
    HeaderNavbarPropsType & {
      drawerMenuItems: DrawerMenuItemType[];
      navbarMenuItems: NavbarMenuItemType[];
    }
>;

export default function HeaderNav({
  fixed,
  breakpoint,

  addNavbarLogo,
  customNavbarLogo,
  navbarLogoPath,

  drawerMenuItems,
  navbarMenuItems,
  isHashLinks,

  addColorSchemeToggle,
  addLanguageToggle,

  addNotificationIconLink,
  notificationIconLinkPath,
  notificationIconLinkCount,

  addRegisterButton,
  registerButtonColor,
  registerButtonPath,
  registerButtonLabel,

  addLoginButton,
  loginButtonColor,
  loginButtonPath,
  loginButtonLabel,

  addLogoutLink,
  logoutLinkColor,
  logoutPath,
  logoutLinkText,

  addShoppingCart,
  shoppingCartLink,
  shoppingCartCount,

  addSearchBar,
  onSearchSubmit,
  searchBarPlaceholder,
}: Props) {
  const { screenWidth } = useScreenWidth();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  return (
    <Header>
      <Nav fixed={fixed} isDrawerOpen={isDrawerOpen}>
        <Navbar
          breakpoint={breakpoint}
          navbarMenuItems={navbarMenuItems}
          isHashLinks={isHashLinks}
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
          addNavbarLogo={addNavbarLogo}
          customNavbarLogo={customNavbarLogo}
          navbarLogoPath={navbarLogoPath}
          addColorSchemeToggle={addColorSchemeToggle}
          addLanguageToggle={addLanguageToggle}
          addNotificationIconLink={addNotificationIconLink}
          notificationIconLinkPath={notificationIconLinkPath}
          notificationIconLinkCount={notificationIconLinkCount}
          addRegisterButton={addRegisterButton}
          registerButtonColor={registerButtonColor}
          registerButtonPath={registerButtonPath}
          registerButtonLabel={registerButtonLabel}
          addLoginButton={addLoginButton}
          loginButtonColor={loginButtonColor}
          loginButtonPath={loginButtonPath}
          loginButtonLabel={loginButtonLabel}
          addLogoutLink={addLogoutLink}
          logoutLinkColor={logoutLinkColor}
          logoutPath={logoutPath}
          logoutLinkText={logoutLinkText}
          addShoppingCart={addShoppingCart}
          shoppingCartLink={shoppingCartLink}
          shoppingCartCount={shoppingCartCount}
          addSearchBar={addSearchBar}
          onSearchSubmit={onSearchSubmit}
          searchBarPlaceholder={searchBarPlaceholder}
        />

        {screenWidth < breakpoint ? (
          <DrawerMenu
            drawerMenuItems={drawerMenuItems}
            isDrawerOpen={isDrawerOpen}
            isHashLinks={isHashLinks}
            setIsDrawerOpen={setIsDrawerOpen}
            addLoginButton={addLoginButton}
            loginButtonColor={loginButtonColor}
            loginButtonLabel={loginButtonLabel}
            loginButtonPath={loginButtonPath}
            addRegisterButton={addRegisterButton}
            registerButtonColor={registerButtonColor}
            registerButtonLabel={registerButtonLabel}
            registerButtonPath={registerButtonPath}
            shoppingCartCount={shoppingCartCount}
            addSearchBar={addSearchBar}
            onSearchSubmit={onSearchSubmit}
            searchBarPlaceholder={searchBarPlaceholder}
          />
        ) : null}
      </Nav>
    </Header>
  );
}
